import http from '../http'

export default {
    all(usuario) {
        return http.get(`usuarios/${usuario}/notas`)
    },

    create(usuario, contenido) {
        return http.post(`usuarios/${usuario}/notas`, { contenido })
    }
}